<template>
    <div v-if="isShown()">
        <LoadingWidget v-if="isLoading()"></LoadingWidget>
        <AlertError v-if="isError()" class="mt-3" :alert="error"></AlertError>
    </div>
</template>

<script>
export default {
    name: 'LoadingDetails',
    props: ['entity', 'error'],
    methods: {
        isShown: function () {
            return (this.isLoading() || this.isError());
        },
        isLoading: function () {
            return this.entity === null && !this.error;
        },
        isError: function () {
            return !!(this.error);
        }
    }
};
</script>
